var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Proximo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_832_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_831_"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#54FEBD",
    cx: 8,
    cy: 44,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_830_"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#54FEBD",
    cx: 20,
    cy: 30,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_829_"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#54FEBD",
    cx: 56,
    cy: 24,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_828_"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#54FEBD",
    cx: 38,
    cy: 39,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_752_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8,
    fill: "#54FEBD",
    width: 62,
    height: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2097_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M63,55H1c-0.55273,0-1-0.44727-1-1V6c0-0.55273,0.44727-1,1-1h62c0.55273,0,1,0.44727,1,1v48 C64,54.55273,63.55273,55,63,55z M2,53h60V7H2V53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2096_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M63,15H1c-0.55273,0-1-0.44727-1-1s0.44727-1,1-1h62c0.55273,0,1,0.44727,1,1S63.55273,15,63,15z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2095_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M51,11c-0.25977,0-0.52051-0.11035-0.70996-0.29004C50.10938,10.51953,50,10.26953,50,10 c0-0.27051,0.10938-0.52051,0.29004-0.70996c0.37012-0.36035,1.04004-0.37012,1.41992,0C51.88965,9.47949,52,9.74023,52,10 s-0.11035,0.51953-0.29004,0.70996C51.51953,10.88965,51.25977,11,51,11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2094_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M55,11c-0.27051,0-0.52051-0.11035-0.70996-0.29004C54.10938,10.51953,54,10.25977,54,10 c0-0.27051,0.10938-0.52051,0.29004-0.70996c0.37012-0.37012,1.0498-0.37012,1.41992,0C55.88965,9.47949,56,9.72949,56,10 c0,0.26953-0.11035,0.51953-0.29004,0.70996C55.51953,10.88965,55.25977,11,55,11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2093_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M59,11c-0.25977,0-0.52051-0.11035-0.70996-0.29004C58.10938,10.51953,58,10.26953,58,10 c0-0.25977,0.10938-0.52051,0.29004-0.70996c0.37988-0.37012,1.04004-0.37012,1.41992,0C59.88965,9.47949,60,9.74023,60,10 c0,0.26953-0.11035,0.51953-0.29004,0.70996C59.51953,10.88965,59.25977,11,59,11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2092_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M8,45c-2.20605,0-4-1.79395-4-4s1.79395-4,4-4s4,1.79395,4,4S10.20605,45,8,45z M8,39 c-1.10254,0-2,0.89746-2,2s0.89746,2,2,2s2-0.89746,2-2S9.10254,39,8,39z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2091_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M20,31c-2.20605,0-4-1.79395-4-4s1.79395-4,4-4s4,1.79395,4,4S22.20605,31,20,31z M20,25 c-1.10254,0-2,0.89746-2,2s0.89746,2,2,2s2-0.89746,2-2S21.10254,25,20,25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2090_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M56,25c-2.20605,0-4-1.79395-4-4s1.79395-4,4-4s4,1.79395,4,4S58.20605,25,56,25z M56,19 c-1.10254,0-2,0.89746-2,2s0.89746,2,2,2s2-0.89746,2-2S57.10254,19,56,19z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2089_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M38,40c-2.20605,0-4-1.79395-4-4s1.79395-4,4-4s4,1.79395,4,4S40.20605,40,38,40z M38,34 c-1.10254,0-2,0.89746-2,2s0.89746,2,2,2s2-0.89746,2-2S39.10254,34,38,34z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2088_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M56,61c-0.55273,0-1-0.44727-1-1V28c0-0.55273,0.44727-1,1-1s1,0.44727,1,1v32 C57,60.55273,56.55273,61,56,61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2087_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M50,61c-0.55273,0-1-0.44727-1-1V33c0-0.55273,0.44727-1,1-1s1,0.44727,1,1v27 C51,60.55273,50.55273,61,50,61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2086_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M44,61c-0.55273,0-1-0.44727-1-1V37c0-0.55273,0.44727-1,1-1s1,0.44727,1,1v23 C45,60.55273,44.55273,61,44,61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2085_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M38,61c-0.55273,0-1-0.44727-1-1V43c0-0.55273,0.44727-1,1-1s1,0.44727,1,1v17 C39,60.55273,38.55273,61,38,61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2084_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M32,61c-0.55273,0-1-0.44727-1-1V39c0-0.55273,0.44727-1,1-1s1,0.44727,1,1v21 C33,60.55273,32.55273,61,32,61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2083_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M26,61c-0.55273,0-1-0.44727-1-1V36c0-0.55273,0.44727-1,1-1s1,0.44727,1,1v24 C27,60.55273,26.55273,61,26,61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2082_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M20,61c-0.55273,0-1-0.44727-1-1V34c0-0.55273,0.44727-1,1-1s1,0.44727,1,1v26 C21,60.55273,20.55273,61,20,61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2081_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M14,61c-0.55273,0-1-0.44727-1-1V42c0-0.55273,0.44727-1,1-1s1,0.44727,1,1v18 C15,60.55273,14.55273,61,14,61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2080_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M8,61c-0.55273,0-1-0.44727-1-1V48c0-0.55273,0.44727-1,1-1s1,0.44727,1,1v12C9,60.55273,8.55273,61,8,61z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2079_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M9.9502,39.73047c-0.23047,0-0.46191-0.0791-0.65039-0.24023 C8.87988,39.13086,8.83105,38.5,9.19043,38.08008l8.09961-9.46094c0.36133-0.4209,0.99219-0.4668,1.41016-0.10938 c0.41992,0.35938,0.46875,0.99023,0.10938,1.41016l-8.09961,9.46094C10.51172,39.6123,10.23145,39.73047,9.9502,39.73047z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2078_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M35.31934,35.66016c-0.15039,0-0.30273-0.03418-0.44629-0.10547l-12.64063-6.32031 c-0.49414-0.24707-0.69434-0.84766-0.44727-1.3418c0.24805-0.49414,0.84766-0.69238,1.3418-0.44727l12.64063,6.32031 c0.49414,0.24707,0.69434,0.84766,0.44727,1.3418C36.03906,35.45801,35.68652,35.66016,35.31934,35.66016z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2077_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M40.30078,35.08008c-0.28711,0-0.57129-0.12207-0.76953-0.36035 c-0.35352-0.42383-0.2959-1.05469,0.12891-1.4082l13.40039-11.16016c0.42383-0.35254,1.05371-0.2959,1.4082,0.12891 c0.35352,0.42383,0.2959,1.05469-0.12891,1.4082L40.93945,34.84863C40.75293,35.00391,40.52637,35.08008,40.30078,35.08008z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2076_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M47,15c-0.55273,0-1-0.44727-1-1V6c0-0.55273,0.44727-1,1-1s1,0.44727,1,1v8 C48,14.55273,47.55273,15,47,15z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.3f019853b7c43656e8de075f3972397b.svg";
export { ForwardRef as ReactComponent };